export const htmlToPlainText = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || doc.body.innerText || '';
}

export const FormatWithEllipsis = (htmlText, number) => {
    return htmlText.length > number ? htmlText.substring(0, number) + "..." : htmlText;
}